import { create } from 'zustand';
import type { GalleryFilters, StarFilter, UserFilter, FavoriteFilter } from '../api/types';

interface FilterState extends GalleryFilters {
  // UI-only — antal kolumner i masonry-griden
  columns: 1 | 2 | 3 | 4;

  setStars: (stars: StarFilter) => void;
  setUser: (user: UserFilter) => void;
  setFavorites: (fav: FavoriteFilter) => void;
  toggleFavorites: () => void;
  setColumns: (cols: 1 | 2 | 3 | 4) => void;
  reset: () => void;
}

const DEFAULTS: GalleryFilters & { columns: 1 | 2 | 3 | 4 } = {
  stars: 'all',
  user: 'all',
  favorites: 'off',
  columns: 3,
};

// Globalt UI-state för gallery-filtren. Vi lägger detta utanför React Query
// eftersom det inte är server-state och vi vill att filtren ska överleva
// route-byten inom samma session.
export const useFilterStore = create<FilterState>((set) => ({
  ...DEFAULTS,
  setStars: (stars) => set({ stars }),
  setUser: (user) => set({ user }),
  setFavorites: (favorites) => set({ favorites }),
  toggleFavorites: () =>
    set((state) => ({ favorites: state.favorites === 'on' ? 'off' : 'on' })),
  setColumns: (columns) => set({ columns }),
  reset: () => set(DEFAULTS),
}));
